import Command from "@ckeditor/ckeditor5-core/src/command";

export default class CustomPluginEnablerCommand extends Command {
    execute() {
        const trackChangesEditing = this.editor.plugins.get('TrackChangesEditing');
        CustomPluginEnablerCommand.plugins.forEach((command) => {
            trackChangesEditing.enableCommand(command);
        })
    }
}

CustomPluginEnablerCommand.plugins = [
    'releasenotes',
    'save',
    'citation',
    'numberedcitation',
    'numberedcitationconverter',
    'renumbercitations',
    'generatecustomguid',
    'reordercopiedcitation',
    'setcursorposition',
    'setcursorpositionright',
    'deletecitations',
    'chevronnav',
    'citationrefnav',
    'citationscitedrefsreorder',
    'citationsreorder',
    'subTemplates',
    'insertimage',
    'insertmedia',
    'insertlink',
    'insertfragmentlink',
    'insertwebemaillink',
    'insertotherdocumentlink',
    'editwebemaillink',
    'toggleTemplateHoverAndSelect',
    'insertsubtemplate',
    'toggleRestrictedEditing',
    'contextmenu',
    'cut',
    'updatemedia',
    'insertaudio',
    'insertvideo',
    'hidedataignoreattribute',
    'removesubtemplate',
    'removeistsubtemplate',
    'insertreference',
    'keyworddefinition',
    'keyworddefinitiondelete',
    'deleteinbatchbyid',
    'unwraplink',
    'aiAssistant'
]
